import LTR from "@brand-icons/ploom/ash/ash-ltr.svg";

import { iconFactory } from "../iconFactory";

export const AshIcon = iconFactory("AshIcon", LTR);
